import { CircleAlert } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useI18nContext } from '@/i18n/i18n-react';
import type { Locales } from '@/i18n/i18n-types';
import { cn } from '@/lib/utils';

interface ConditionEditSheetTargetFooterProps {
  summary: string;
  error?: string;
  targetedUserCount: number | undefined;
  totalUserCount: number | undefined;
  isLoading: boolean;
  locale: Locales;
  className?: string;
}

export function ConditionEditSheetTargetFooter({
  summary,
  error,
  targetedUserCount,
  totalUserCount,
  isLoading,
  locale,
  className,
}: ConditionEditSheetTargetFooterProps) {
  const { LL } = useI18nContext();

  if (error) {
    return (
      <div className={cn('flex items-start gap-1.5', className)}>
        <CircleAlert className="mt-0.5 size-3.5 shrink-0 text-destructive" />
        <p className="text-sm text-destructive">{error}</p>
      </div>
    );
  }

  const showCounts =
    !isLoading &&
    targetedUserCount !== undefined &&
    totalUserCount !== undefined;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <p className="text-sm text-muted-foreground">{summary}</p>
      {isLoading ? (
        <Skeleton className="h-4 w-40" />
      ) : showCounts ? (
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-primary tabular-nums">
            {targetedUserCount.toLocaleString(locale)}
          </span>
          {LL.audiences.filters.editSheet.targetCountSuffix({
            total: totalUserCount.toLocaleString(locale),
          })}
        </p>
      ) : null}
    </div>
  );
}
